import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";

let env = process.env.REACT_APP_B2B_API_BASE_URL;

//Profile Service
export const profileService = async () => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.Profile.api}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};
